
  document.addEventListener('DOMContentLoaded', function () {
    const sectionId = 'template--19513287016490__wj_color_nav_sync';
    const sectionRoot = document.getElementById('shopify-section-' + sectionId) || document.querySelector('[id^="pdp-"] .wj-color-nav')?.closest('[id^="pdp-"]');
    const navRoot = sectionRoot ? sectionRoot.querySelector('.wj-color-nav') : null;
    const spacer = sectionRoot ? sectionRoot.querySelector('.wj-color-nav-spacer') : null;
    const container = document.getElementById('nav-swiper-' + sectionId);

    if (!sectionRoot || !navRoot || !container) return;

    const optionPosition = Number(navRoot.dataset.optionPosition || 0);
    const navItems = Array.from(container.querySelectorAll('.wj-color-nav-item'));
    const localProduct = document.querySelector('.torras-main-product');
    let syncingLocalVariant = false;
    let stickyStart = 0;
    let lastScrollY = window.scrollY;

    if (!navItems.length) return;

    if (typeof loadColorSwatches === 'function' && !window.loadedBackgroundColorSwatches && container.querySelector('[data-color]')) {
      loadColorSwatches();
    }

    const swiper = typeof Swiper === 'function'
      ? new Swiper(container, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          freeMode: true,
          slideToClickedSlide: true,
        })
      : null;

    function setStickyState() {
      const topOffset = 0;
      const currentY = window.scrollY;
      const triggerOffset = Math.max(8, Math.round(navRoot.offsetHeight * 0.35));
      const stickyThreshold = Math.max(0, stickyStart - topOffset - triggerOffset);
      const shouldFix = currentY >= stickyThreshold;

      if (!shouldFix) {
        sectionRoot.classList.remove('is-fixed');
        sectionRoot.classList.remove('is-fixed-hidden');
        if (spacer) {
          spacer.style.height = '0px';
        }
        lastScrollY = currentY;
        return;
      }

      const isScrollingUp = currentY < lastScrollY;
      const isNearThreshold = currentY <= stickyThreshold + 24;

      sectionRoot.classList.add('is-fixed');
      sectionRoot.classList.toggle('is-fixed-hidden', isScrollingUp && !isNearThreshold);

      if (spacer) {
        spacer.style.height = navRoot.offsetHeight + 'px';
      }

      lastScrollY = currentY;
    }

    function updateStickyMetrics() {
      const wasFixed = sectionRoot.classList.contains('is-fixed');

      if (wasFixed) {
        sectionRoot.classList.remove('is-fixed');
      }

      if (spacer) {
        spacer.style.height = '0px';
      }

      stickyStart = sectionRoot.getBoundingClientRect().top + window.scrollY;
      setStickyState();
    }

    function getItemByValue(value) {
      return navItems.find((item) => item.dataset.value === value);
    }

    function getIndexByValue(value) {
      return navItems.findIndex((item) => item.dataset.value === value);
    }

    function updateActiveTab(index) {
      navItems.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (swiper && index >= 0) {
        swiper.slideTo(index);
      }
    }

    function broadcastColorSwitch(index, value, source) {
      document.dispatchEvent(
        new CustomEvent('wj-color-switch', {
          detail: { index: index, value: value, source: source },
        })
      );
    }

    function syncVariantPicker(value) {
      if (!optionPosition || !value) return false;

      let didSync = false;

      const localButton = localProduct && Array.from(localProduct.querySelectorAll('[data-variant-button], [data-option-value]')).find((button) =>
        button.dataset.variantColor === value ||
        (Number(button.dataset.optionPosition) === optionPosition && button.dataset.optionValue === value)
      );
      if (localButton) {
        syncingLocalVariant = true;
        try { localButton.click(); didSync = true; }
        finally { syncingLocalVariant = false; }
      }

      document.querySelectorAll('variant-radios').forEach((variantRadios) => {
        const fieldset = variantRadios.querySelectorAll('fieldset')[optionPosition - 1];
        if (!fieldset) return;

        const input = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((radio) => radio.value === value);
        if (!input) return;

        if (!input.checked) {
          input.checked = true;
        }

        input.dispatchEvent(new Event('change', { bubbles: true }));
        didSync = true;
      });

      return didSync;
    }

    function handleVariantPickerChange(value, source) {
      const index = getIndexByValue(value);
      if (index < 0) return;

      updateActiveTab(index);
      broadcastColorSwitch(index, value, source);
    }

    navItems.forEach((item, index) => {
      item.addEventListener('click', function () {
        const value = item.dataset.value;

        updateActiveTab(index);
        syncVariantPicker(value);
        broadcastColorSwitch(index, value, 'wj-color-nav');
      });
    });

    localProduct?.querySelector('[data-product-form] input[name="id"]')?.addEventListener('change', (event) => {
      if (syncingLocalVariant) return;
      const button = Array.from(localProduct.querySelectorAll('[data-variant-button]')).find((item) => item.dataset.variantId === event.target.value);
      if (button?.dataset.variantColor) handleVariantPickerChange(button.dataset.variantColor, 'product-variant-picker');
    });

    if (optionPosition) {
      document.querySelectorAll('variant-radios').forEach((variantRadios) => {
        const fieldset = variantRadios.querySelectorAll('fieldset')[optionPosition - 1];
        if (!fieldset) return;

        fieldset.addEventListener('change', function (event) {
          const target = event.target;
          if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;
          handleVariantPickerChange(target.value, 'product-variant-picker');
        });

        const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          const checkedItem = getItemByValue(checkedInput.value);
          if (checkedItem) {
            updateActiveTab(getIndexByValue(checkedInput.value));
          }
        }
      });
    }

    document.addEventListener('wj-color-switch', function (event) {
      if (!event.detail || event.detail.source === 'wj-color-nav') return;

      if (typeof event.detail.value === 'string') {
        const item = getItemByValue(event.detail.value);
        if (item) {
          updateActiveTab(getIndexByValue(event.detail.value));
          return;
        }
      }

      if (typeof event.detail.index === 'number') {
        updateActiveTab(event.detail.index);
      }
    });

    updateStickyMetrics();
    window.addEventListener('scroll', setStickyState, { passive: true });
    window.addEventListener('resize', updateStickyMetrics);
    window.addEventListener('load', updateStickyMetrics);
  });
